






















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import User from "@/models/user";

@Component({
  computed: {
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class Delete extends Vue {
  user!: User;
  loading = false;
  hasActiveSubscription!: boolean;
  confirmation = "";

  closeAccount() {
    this.loading = true;

    this.$store
      .dispatch("authentication/deleteUser", this.confirmation)
      .then(() => {
        this.$message({
          message: "Your account has been deleted",
          type: "success",
        });
        setTimeout(() => {
          this.$store.dispatch(`authentication/logout`);
        }, 1000);
      })
      .finally(() => {
        this.confirmation = "";
        this.loading = false;
      });
  }
}
